import { render } from "./member.vue?vue&type=template&id=2c0dc21e&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"

import "./member.vue?vue&type=style&index=0&id=2c0dc21e&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0dc21e"]])

export default __exports__